exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-48706f36]{font-size:large;color:#000}", ""]);

// exports
